module.exports = __webpack_public_path__ + "static/media/checkMark.e83e9270.svg";